import React from "react";

function parseNumber(value) {
  if (value === "") return "";
  const n = Number(value);
  return Number.isFinite(n) ? n : value;
}

function isCabinetNode(node) {
  const category = String(
    node?.category || node?.definition?.category || ""
  ).toLowerCase();

  return category.includes("cabinet");
}

export default function SelectedCabinetSimplePanel({
  selectedNode,
  resolvedNode,
  onChangeNode,
  onQuickAdd,
}) {
  const node = selectedNode || resolvedNode;

  if (!node) {
    return (
      <div className="border rounded p-3 bg-slate-50 text-sm text-slate-500">
        Select cabinet to edit dimensions.
      </div>
    );
  }

  if (!isCabinetNode(resolvedNode || node)) {
    return (
      <div className="border rounded p-3 bg-slate-50 text-sm text-slate-500">
        Simple cabinet settings are available when a cabinet/corpus box is selected.
      </div>
    );
  }

  const overrides = node.parameterOverrides || {};
  const effective = resolvedNode?.effectiveParameters || {};

  function updateParam(key, value) {
    onChangeNode?.({
      id: node.id,
      parameterOverrides: {
        ...(node.parameterOverrides || {}),
        [key]: parseNumber(value),
      },
    });
  }

  return (
    <div className="border rounded p-3 bg-white space-y-3">
      <div>
        <div className="font-semibold text-sm">Selected cabinet</div>
        <div className="text-xs text-slate-500">
          Osnovne dimenzije i parametri korpusa.
        </div>
      </div>

      <div className="grid grid-cols-3 gap-2">
        {["width", "height", "depth"].map((key) => (
          <div key={key}>
            <label className="text-xs text-slate-500 capitalize">{key}</label>
            <input
              type="number"
              value={overrides[key] ?? ""}
              placeholder={String(effective[key] ?? "")}
              onChange={(e) => updateParam(key, e.target.value)}
              className="w-full px-2 py-1 border rounded text-sm"
            />
          </div>
        ))}
      </div>

      <div className="grid grid-cols-2 gap-2">
        

        <div>
          <label className="text-xs text-slate-500">Floor offset</label>
          <input
            type="number"
            value={overrides.floorOffset ?? ""}
            placeholder={String(effective.floorOffset ?? 0)}
            onChange={(e) => updateParam("floorOffset", e.target.value)}
            className="w-full px-2 py-1 border rounded text-sm"
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-2">
        <button
          type="button"
          onClick={() => updateParam("height", 720)}
          className="px-3 py-2 border rounded bg-slate-50 text-sm"
        >
          Base 720
        </button>

        <button
          type="button"
          onClick={() => updateParam("height", 2000)}
          className="px-3 py-2 border rounded bg-slate-50 text-sm"
        >
          Tall 2000
        </button>
      </div>

      <div className="border-t pt-3 space-y-2">
  <div className="text-xs font-semibold text-slate-500">
    Quick add
  </div>

  <div className="grid grid-cols-2 gap-2">
    <button
      type="button"
      onClick={() => onQuickAdd?.("left")}
      className="px-3 py-2 border rounded bg-slate-50 text-sm"
    >
      Add Left
    </button>

    <button
      type="button"
      onClick={() => onQuickAdd?.("right")}
      className="px-3 py-2 border rounded bg-slate-50 text-sm"
    >
      Add Right
    </button>

    <button
      type="button"
      onClick={() => onQuickAdd?.("front")}
      className="px-3 py-2 border rounded bg-slate-50 text-sm"
    >
      Add Front
    </button>

    <button
      type="button"
      onClick={() => onQuickAdd?.("back")}
      className="px-3 py-2 border rounded bg-slate-50 text-sm"
    >
      Add Back
    </button>
  </div>
</div>

<div className="grid grid-cols-2 gap-2 pt-2 border-t">

  <button
    type="button"
    onClick={() => onQuickAdd?.("cornerLeft")}
    className="px-3 py-2 border rounded bg-blue-50 text-sm"
  >
    Turn Left + Add
  </button>

  <button
    type="button"
    onClick={() => onQuickAdd?.("cornerRight")}
    className="px-3 py-2 border rounded bg-blue-50 text-sm"
  >
    Turn Right + Add
  </button>
</div>
    </div>
  );
}